/**
 * 
 * Check transform-object.md file for more information
 */
const HTransformObject = (
  obj: any,
  opt?: {
    noTransformArrayToObject?: boolean;
    removeEmptyStrings?: boolean;
    removeEmptyArray?: boolean;
    removeEmptyObjects?: boolean;
    removeNull?: boolean;
    removeUndefined?: boolean;
  }
) => {
  const newObj: any = {};
  for (const key in obj) {
    if (obj[key] === 0 || obj[key] === false) {
      newObj[key] = 0;
    } else if (obj[key] === true || obj[key] === 1) {
      newObj[key] = 1;
    } else if (obj[key] === null || obj[key] === undefined) {
      if (opt?.removeNull) {
        delete newObj[key];
      }
    } else if (
      Array.isArray(obj[key]) &&
      obj[key].length === 0 &&
      opt?.removeEmptyArray
    ) {
      delete newObj[key];
    } else if (Array.isArray(obj[key]) && opt?.noTransformArrayToObject) {
      newObj[key] = obj[key];
    } else if (obj[key] === "" && opt?.removeEmptyStrings) {
      delete newObj[key];
    } else if (obj[key] instanceof Blob || obj[key] instanceof File) {
      newObj[key] = obj[key];
    } else if (typeof obj[key] === "object" && Object.keys(obj[key]).length === 0) {
      if (opt?.removeEmptyObjects) {
        delete newObj[key];
      }
    } else {
      //support for nested objects
      if (typeof obj[key] === "object") {
        newObj[key] = HTransformObject(obj[key], opt);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  return newObj;
};

export default HTransformObject;

// console.log({
//     key: key,
//     file: obj[key] instanceof File,
//     blob: obj[key] instanceof Blob,
//     fileList: obj[key] instanceof FileList,
//     string: typeof obj[key] === "string",
//     array: Array.isArray(obj[key]),
//     object: typeof obj[key] === "object",
//     number: typeof obj[key] === "number",
//     boolean: typeof obj[key] === "boolean",
//     function: typeof obj[key] === "function",
//     undefined: obj[key] === undefined,
//     null: obj[key] === null,
//     symbol: typeof obj[key] === "symbol",
// })
